import { useState, useEffect } from "react"

/*
    This hook was taken from: https://billyjacoby.com/intersectionobserver-api-with-react-hooks/
    Modified slightly to allow for prerendering

    Usage:
    const someRef = useRef();
    const [inView, entry] = useIntersectionObserver(someRef, {
        threshold: 0.1
    });

    useEffect(() => {
        // this will run when the element is inView;
    }, [inView]);

    Note: it only triggers once!

*/

export const useIntersectionObserver = ( ref, { threshold, root, rootMargin }) => {

    const [state, setState] = useState({
        inView: false,
        triggered: false,
        entry: undefined,
    })

    const observer = (typeof window !== "undefined")
        ? new IntersectionObserver((entries, observerInstance) => {
                // checks to see if the element is intersecting
                if (entries[0].intersectionRatio > 0) {
                    // if it is update the state, we set triggered as to not re-observe the element
                    setState({
                        inView: true,
                        triggered: true,
                        entry: observerInstance,
                    })
                    // unobserve the element
                    observerInstance.unobserve(ref.current)
                }
                return
            },
            {
                threshold: threshold || 0,
                root: root || null,
                rootMargin: rootMargin || "0%",
            }
        )
        : undefined

    useEffect(() => {
        // check that the element exists, and has not already been triggered
        if (ref.current && !state.triggered) {
            observer && observer.observe(ref.current)
        }
    })

    return [state.inView, state.entry]

}